var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataWrapperList.length === 0)?_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.emptyListMessage)+" ")])]):_c('div',{},_vm._l((_vm.dataWrapperList),function(wrapper){return _c('div',{key:wrapper.attributes.id},[_c(_vm.listItemComponent,{tag:"component",attrs:{"item":wrapper.attributes}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }